import type { I18nOptions } from "vue-i18n";
import { createI18n } from "vue-i18n";
import Config from "@/common/config";
import messages from "@intlify/unplugin-vue-i18n/messages";

export enum Locales {
  DE = "de",
  EN = "en",
  ES = "es",
}

export const langs = {
  [Locales.DE]: { name: "Deutsch" },
  [Locales.EN]: { name: "English" },
  [Locales.ES]: { name: "Spanish" },
};

const datetimeFormats: I18nOptions["datetimeFormats"] = {
  [Locales.DE]: {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  [Locales.EN]: {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  [Locales.ES]: {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
};

const getInitialLocale = (): string => {
  const storedValues = window.localStorage.getItem(Config.localeDataPersistKey);
  const initialLocale: string =
    storedValues !== null
      ? (JSON.parse(storedValues).locale ?? navigator.language)
      : navigator.language;
  const splitLocale = initialLocale.split("-")[0];

  // If splitLocale is not "en", "de", or "es", return "en".
  if (!["en", "de", "es"].includes(splitLocale)) {
    return "en";
  }

  // Reduce an RFC5646 language tag that may be provided by navigator.language to just the language.
  // See https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language
  return splitLocale;
};

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: Locales.EN,
  messages: messages,
  datetimeFormats: datetimeFormats,
  warnHtmlMessage: false,
  warnHtmlInMessage: "off",
});
